export const PERMISSION_LEVELS = [
  { value: 'User', label: 'User' },
  { value: 'Admin', label: 'Admin' },
];

export const INTERNAL_USER_FEATURES = [
  { label: 'Internal Users', value: 'internal_users' },
  { label: 'Law Firms', value: 'law_firms' },
  { label: 'Law Firm User Management', value: 'law_firm_users' },
  { label: 'Bond Numbers', value: 'bond_numbers' },
  { label: 'Law Schools', value: 'law_schools' },
  { label: 'Professional Guardians', value: 'professional_guardians' },
  { label: 'Carriers', value: 'carriers' },
  { label: 'Premiums', value: 'premiums' },
  { label: 'States', value: 'states' },
  { label: 'Bond Types', value: 'bond_types' },
  { label: 'Obligees', value: 'obligees' },
  { label: 'Enhancement Request', value: 'enhancement_request' },
  { label: 'Analytics', value: 'analytics' },
  { label: 'Bond Archives', value: 'bond_archives' },
  { label: 'Historic Bonds Creation', value: 'create_historic_bonds' },
  { label: 'Paralegal Management', value: 'LEGAL_SERVICE_PARALEGAL_MANAGEMENT' },
  { label: 'Approve Bonds', value: 'approve_bonds' },
  { label: 'Announcements', value: 'announcements' },
  { label: 'Support Requests', value: 'support_requests' },
];

export const INTERNAL_USER_ENDPOINTS = {
  create: '/invite-internal-user',
  get: (internalUserId) => `/get-internal-user/${internalUserId}`,
  update: (internalUserId) => `/internal-user/${internalUserId}`,
  resendInvite: (internalUserId) => `/resend-internal-user-invite/${internalUserId}`,
  emailExists: '/email-exists',
};

export const buildInternalUserPayload = ({
  formData,
  permissionLevel,
  permissions,
  isPiiUser,
  isCriticalUser,
  sendInvite,
}) => ({
  features: permissionLevel === 'Admin' ? [] : permissions,
  full_name: `${formData.firstName} ${formData.lastName}`,
  phonenumber: formData.phoneNumber,
  user: {
    email: formData.email,
    first_name: formData.firstName,
    last_name: formData.lastName,
  },
  is_admin: permissionLevel === 'Admin',
  is_pii_user: isPiiUser,
  is_critical_user: isCriticalUser,
  ...(sendInvite !== undefined ? { send_invite: sendInvite } : {}),
});
